import React from "react";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./testomonial.scss";

import testo1 from "../../Assets/images/Testomonial/testo-1.jpg";
import testo2 from "../../Assets/images/Testomonial/testo-2.jpg";
import testo3 from "../../Assets/images/Testomonial/testo-3.jpg";
import testo4 from "../../Assets/images/Testomonial/testo-4.jpg";

const TestoCards = [
  {
    img: testo1,
    title: "Web Designer",
    name: "Person1",
  },
  {
    img: testo2,
    title: "UI/Ux Designer",
    name: "Person2",
  },
  {
    img: testo3,
    title: "Business Analyst",
    name: "Person3",
  },
  {
    img: testo4,
    title: "HR",
    name: "Person4",
  },
];

const Testomonials = () => {
  return (
    <div className="section testomonial">
      <div className="container">
        <p data-aos="fade-up" className="text-center" style={{fontFamily:"satisfy, cursive"}}>Testomonials</p>
        <h1 data-aos="fade-up" className="text-center">What Our Client Say!</h1>
        <p data-aos="fade-up" className="text-center">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos
          tempore aliquam non! Mollitia dolor officiis corporis et doloribus
          expedita.
        </p>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <Carousel autoPlay showArrows={true}>
              {TestoCards.map((card) =>(
                <div className="carousel-card">
                  <div className="card-text">
                    <p>
                      Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                      Porro a consequatur tempore dolorem velit quisquam
                      maiores, quam hic tenetur illum quidem sequi laborum
                      dolorum eligendi amet quod inventore perspiciatis repellat
                      unde dicta deserunt? Quo corrupti architecto blanditiis
                      vitae.
                    </p>

                    <div className="card-img">
                      <img src={card.img} alt={card.name} />
                    </div>
                  </div>
                  <div className="card-title">
                    <h6>
                      {card.name} <br /> {card.title}!
                    </h6>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testomonials;
